module.exports = __webpack_public_path__ + "img/brush-greenD.8db685a4.png";